import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import CheckboxBox from './_CheckboxBox.js';
import CheckboxButton from './_CheckboxButton.js';
import CheckboxContainer from './_CheckboxContainer.js';
import CheckboxLabel from './_CheckboxLabel.js';

var _excluded = ["checkboxButtonStyles", "checkboxInputStyles", "parentError", "error", "field", "hideLabel", "initialValue", "label", "theme", "title", "value", "isInline"];
var CheckboxField = function CheckboxField(_ref) {
  var checkboxButtonStyles = _ref.checkboxButtonStyles,
    checkboxInputStyles = _ref.checkboxInputStyles,
    parentError = _ref.parentError,
    error = _ref.error,
    field = _ref.field,
    hideLabel = _ref.hideLabel,
    initialValue = _ref.initialValue,
    label = _ref.label,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme,
    title = _ref.title,
    value = _ref.value,
    _ref$isInline = _ref.isInline,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CheckboxContainer, {
    htmlFor: field,
    hideLabel: hideLabel
  }, /*#__PURE__*/React.createElement(CheckboxBox, _extends({}, rest, {
    style: checkboxInputStyles,
    checked: value || initialValue || false,
    id: field,
    error: error || parentError,
    theme: theme,
    type: 'checkbox',
    value: (value || initialValue || false).toString()
  })), /*#__PURE__*/React.createElement(CheckboxButton, {
    style: checkboxButtonStyles,
    title: title,
    theme: theme,
    error: error || parentError
  }), /*#__PURE__*/React.createElement(CheckboxLabel, {
    hideLabel: hideLabel,
    title: title
  }, label));
};
var CheckboxField$1 = withDefaultTheme(/*#__PURE__*/memo(CheckboxField));

export default CheckboxField$1;
